<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-20 15:48:35
 * @LastEditTime: 2019-08-22 18:57:27
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="index">
    <Slider1 :sliderArr='sliderArr'/>
    <div class="main">
      <div class="dt fl mar">
        <div class="title"><img src="@/assets/images/dt.png"></div>
        <div class="hometext">
          <ul>
            <li v-for="item in newsTitles" > {{item.publishTime}}&nbsp;&nbsp;|&nbsp;&nbsp;<a @click="gotoDetail(item)">{{item.title.slice(0,30)}}</a>
            </li>
          </ul>
        </div>
        <div class="bto2"><a @click="goto()"><img src="@/assets/images/bto.png"></a></div>
      </div>
      <div class="sp fl mar">
        <div class="title" style="margin-top: 0px;font-size: 20px"><span>联系我们</span></div>
        <div style="border: 1px">
          <p style="margin-top: 50px">公司电话：028-87030721</p>
          <p>公司地址：四川省成都市武科西二路189号</p>
          <p>联系方式：黄先生：18349366222  夏先生：13438831816</p>
        </div>
        <!--<div class="title"><img src="@/assets/images/sp.png"></div>-->
        <!--<div class="video">-->
          <!--<video v-bind:src="showVideoPath"-->
                 <!--width="100%" height="100%"-->
                 <!--class="avatar video-avatar"-->
                 <!--controls="controls"></video>-->

        <!--</div>-->
        <!--<div class="bto1"><a @click="goto_vedio() "><img src="@/assets/images/bto.png"></a></div>-->
      </div>
    </div>
  </div>
</template>

<script>
  import Slider1 from '@/components/Slider1';
  import List from '@/components/List';
  import axios from 'axios';
  import Vue from 'vue'
  export default {
    name: 'index',
    components: {
      Slider1,
      List
    },
    data() {
      return {
        // sliderArr: [
        //   require('@/assets/images/20151224092539628.jpg'),
        //   require('@/assets/images/20151224092549746.jpg'),
        //   require('@/assets/images/20151224092557469.jpg'),
        //   require('@/assets/images/index_banner_1.png')
        // ],
        sliderArr: [],
        showVideoPath: "",
        intro: {
          title: '公司简介',
          content: '本公司座于中国品牌之都(晋江),靠近泉州 晋江机场。自公司创建以来，几经商海搏击，冲 破市场重重阻力，取得不断的发展。公司十分注 重产品质量与科技创新，并聘请高级工程师及技 术员数名，拥有雄厚的技术力量，是一家专业研 制橡胶塑料机械企业赢得用是一家专业研 制橡胶塑料机械企业赢得用是一家专业研 制橡胶塑料机械企业赢得用是一家专业研 制橡胶塑料机械企业赢得用是一家专业研 制橡胶塑料机械企业赢得用是一家专业研 制橡胶塑料机械企业赢得用是一家专业研 制橡胶塑料机械企业赢得用是一家专业研 制橡胶塑料机械企业赢得用是一家专业研 制橡胶塑料机械企业赢得用'
        },
        newsTitles: [],
        contact: {
          title: '联系我们',
          TEL: '0595-0000000',
          imgURL: require('@/assets/images/index_feedback.jpg')
        }
      }
    },
    created() {
      this.getPic();
      this.getCompanyNews();
      this.getVideo();
    },
    methods: {
      // 跳转到详情页
      gotoDetail(item){
        let obj = {
          path: '/gsxw/gsxw_info/-1',
          title: '公司新闻'
        };
        Vue.prototype.$item = item;
        this.$router.push(obj);
      },
      // 跳转到公司新闻
      goto() {
        let obj = {
          path: '/gsxw/gsxw_info/0',
          title: '公司新闻'
        };
        this.$router.push(obj);
      },
      // 跳转到公司新闻
      goto_vedio() {
        let obj = {
          path: '/video/video_info',
          title: '公司视频'
        };
        this.$router.push(obj);
      },
      // 获取轮播图
      getPic() {
        axios({
          method: 'get',
          url: "/web/api/picList",
          params: {
            pageNum: 1,
            pageSize: 10,
          }
        }).then(res => {
          this.sliderArr = [];
          res.data.rows.forEach(r => {
            this.sliderArr.push(r.ossUrl);
          })
        })
      },
//获取公司动态
      getCompanyNews() {
        axios({
          method: 'get',
          url: "/web/api/getNews",
          params: {
            pageNum: 1,
            pageSize: 6,
            type: "gsxw",
            type2: "gsxw"
          }
        }).then(res => {
          res.data.rows.forEach(r => {
            this.newsTitles.push(r);

          })
        })
      },
      //获取首页视频
      getVideo() {
        axios({
          method: 'get',
          url: "/web/api/getVideo",
          params: {
            pageNum: 1,
            pageSize: 1,
          }
        }).then(res => {
          if (res.data.rows) {
            this.showVideoPath = res.data.rows[0].url;
          }
        })
      },
      nextPage() {
        this.$router.push({path: '/contact'})
      },
    },
    watch: {
      '$route'(to, from) {
        console.log(this.$route.name)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .main {
    width: 1201px;
    height: 250px;
    padding-bottom: 35px;
    margin: 10px auto;
  }

  .dt {
    width: 530px;
    height: 250px;
  }

  .mar {
    margin-left: 50px;
  }

  .fl {
    float: left;
  }

  .title {
    width: 100%;
    height: 47px;
    border-bottom: dotted 1px #bbb;

  }

  .img {
    cursor: pointer;
  }

  .hometext {
    width: 530px;
    height: 150px;
    font-size: 12px;
    padding: 10px;
  }

  ol, ul {
    list-style: none;
    padding: 1px;
  }

  .hometext ul li {
    height: 25px;
    line-height: 25px;
    text-align: left;
  }

  .hometext ul li a {
    font-size: 12px;
    color: #404040;
  }

  a {
    outline: none;
    text-decoration: none;
    cursor: pointer;
  }

  .bto2 {
    margin-top: 10px;
  }

  .sp {
    width: 550px;
    height: 250px;
  }

  .video {
    width: 277px;
    height: 161px;
    margin: 0 auto;
    background: #000;
    margin-top: 10px;
  }

  .bto1 {
    float: right;
  }

  .end {
    width: 100%;
    height: 92px;
    background: #1a478a;
    margin-top: 12px;
  }

  .end1 {
    width: 1200px;
    height: 92px;
    margin: 0 auto;
  }

  .end1_img1 {
    width: 81px;
    height: 25px;
    padding: 33px 25px;
  }

  .end1_img2 {
    width: 81px;
    height: 80px;
    padding: 6px 0;
  }

  .end2 {
    width: 470px;
    height: 30px;
    margin: 30px 125px;
  }

  .end3 {
    width: 20px;
    height: 50px;
    margin: 20px 60px;
  }

  .content {
    width: 980px;
    margin: 0px auto 20px;

    ::v-deep .List {
      display: inline-block;
      vertical-align: top;
      width: 30%;
      padding: 10px;

      > .title {
        border-bottom: 1px dashed #ccc;
        width: 270px;
        height: 40px;
        line-height: 40px;
        color: #e61f1f;
        font-size: 14px;
      }

      .content {
        padding: 10px 0px;

        li {
          word-break: break-all;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 24px;
        }

        .title {
          color: #e61f1f;
          font-size: 16px;
          width: 270px;
          line-height: 36px;
          font-weight: bolder;
          padding: 0px 0px 10px;
        }

        .TEL {
          color: #666;
          width: 270px;
          font-size: 14px;
          text-align: right;
          padding: 10px 0px;
        }

        img {
          cursor: pointer;
        }
      }
    }

    .intro {
      .content div {
        text-indent: 2em;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 2
      }
    }

    &::after {
      content: '';
      vertical-align: top;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/index.vue